import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import StudentForm from './pages/StudentForm';
import StudentView from './pages/StudentView';
import Rooms from './pages/Rooms';
import Fees from './pages/Fees';
import Staff from './pages/Staff';
import Attendance from './pages/Attendance';
import Salaries from './pages/Salaries';
import Bills from './pages/Bills';
import Maintenance from './pages/Maintenance';
import Reports from './pages/Reports';

function PrivateRoute({ children }) {
  const { isAuth } = useAuth();
  return isAuth ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  const { isAuth } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={isAuth ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/students" element={<PrivateRoute><Students /></PrivateRoute>} />
      <Route path="/students/add" element={<PrivateRoute><StudentForm /></PrivateRoute>} />
      <Route path="/students/:id" element={<PrivateRoute><StudentView /></PrivateRoute>} />
      <Route path="/students/:id/edit" element={<PrivateRoute><StudentForm /></PrivateRoute>} />
      <Route path="/rooms" element={<PrivateRoute><Rooms /></PrivateRoute>} />
      <Route path="/fees" element={<PrivateRoute><Fees /></PrivateRoute>} />
      <Route path="/staff" element={<PrivateRoute><Staff /></PrivateRoute>} />
      <Route path="/attendance" element={<PrivateRoute><Attendance /></PrivateRoute>} />
      <Route path="/salaries" element={<PrivateRoute><Salaries /></PrivateRoute>} />
      <Route path="/bills" element={<PrivateRoute><Bills /></PrivateRoute>} />
      <Route path="/maintenance" element={<PrivateRoute><Maintenance /></PrivateRoute>} />
      <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
